import { ReactElement, useEffect, useState } from 'react'

import getMFEConfig from 'helpers/getMFEConfig'

import useNavigateOnRedirect from 'hooks/useNavigateOnRedirect'

import { RewardsPage } from 'rewards-mfe'
import { useCreditAccounts } from 'const/syfApiQueries'
import { useDispatch } from 'react-redux'
import { updateSelectedAccount } from 'redux/modals/actions'
import { VerticalCardLoader } from 'syf-component-library/ui/atoms'
import { LoaderContainer, MFEFullPageWrapper } from 'pages/subcomponents'

const Rewards = (): ReactElement => {
  useNavigateOnRedirect()

  const dispatch = useDispatch()
  const [selectedAccountId, setSelectedAccountId] = useState(() =>
    sessionStorage.getItem('selectedAccountId')
  )

  const { data: { accounts = [] } = {} } = useCreditAccounts()

  useEffect(() => {
    if (!accounts?.length) return
    if (sessionStorage.getItem('isTJXDeepLinking') === 'true') {
      const accountId = accounts[0]?.info?.['cipher.accountId']
      dispatch(updateSelectedAccount(accountId))
      setSelectedAccountId(accountId)
      sessionStorage.removeItem('isTJXDeepLinking')
    }
  }, [accounts, dispatch])

  const mfeConfig = getMFEConfig('mfe')

  return (
    <MFEFullPageWrapper>
      {!selectedAccountId ? (
        <LoaderContainer>
          <VerticalCardLoader />
        </LoaderContainer>
      ) : (
        <RewardsPage config={mfeConfig} />
      )}
    </MFEFullPageWrapper>
  )
}

export default Rewards
